(() => {
  if (window.cutimArticleToc) return;
  const desktop = window.matchMedia('(min-width: 1100px)');

  function initialize(root = document) {
    window.cutimArticleFaq?.initialize(root);
    root.querySelectorAll('.cutim-article-body').forEach((body) => {
      if (body.dataset.tocReady) return;
      body.dataset.tocReady = 'true';
      const layout = body.closest('.cutim-article-layout');
      const headings = [...body.querySelectorAll('h2')].filter((heading) => heading.textContent.trim());
      const content = body.cloneNode(true);
      content.querySelectorAll('script,style').forEach((node) => node.remove());
      if (!layout || content.textContent.trim().split(/\s+/).length < 800 || headings.length < 4 || body.querySelector('nav, [data-toc]')) return;
      const nav = document.createElement('nav');
      nav.className = 'cutim-article-toc';
      nav.setAttribute('aria-label', 'Table of contents');
      const details = document.createElement('details');
      details.open = desktop.matches;
      const summary = document.createElement('summary');
      summary.textContent = 'On this page';
      const list = document.createElement('ol');
      const tooltip = document.createElement('div');
      tooltip.className = 'cutim-toc-tooltip';
      tooltip.id = body.id + '-toc-tooltip';
      tooltip.setAttribute('role', 'tooltip');
      tooltip.hidden = true;
      let activeLink;
      let closeTimer;
      const hide = () => {
        clearTimeout(closeTimer);
        tooltip.hidden = true;
        activeLink?.removeAttribute('aria-describedby');
        activeLink = null;
      };
      const scheduleHide = () => { closeTimer = setTimeout(hide, 120); };
      const show = (link) => {
        clearTimeout(closeTimer);
        hide();
        if (!desktop.matches || link.scrollWidth <= link.clientWidth) return;
        activeLink = link;
        tooltip.textContent = link.textContent;
        tooltip.hidden = false;
        link.setAttribute('aria-describedby', tooltip.id);
        const rect = link.getBoundingClientRect();
        const tip = tooltip.getBoundingClientRect();
        tooltip.style.left = Math.max(8, Math.min(rect.left - tip.width - 12, innerWidth - tip.width - 8)) + 'px';
        tooltip.style.top = Math.max(8, Math.min(rect.top, innerHeight - tip.height - 8)) + 'px';
      };
      headings.forEach((heading, index) => {
        if (!heading.id) {
          let id = body.id + '-heading-' + (index + 1);
          while (document.getElementById(id)) id += '-section';
          heading.id = id;
        }
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = '#' + encodeURIComponent(heading.id);
        link.textContent = heading.textContent.replace(/\s+/g, ' ').trim();
        link.addEventListener('pointerenter', () => show(link));
        link.addEventListener('pointerleave', scheduleHide);
        link.addEventListener('focus', () => show(link));
        link.addEventListener('blur', hide);
        link.addEventListener('keydown', (event) => { if (event.key === 'Escape') hide(); });
        link.addEventListener('click', () => {
          hide();
          if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
          heading.focus({ preventScroll: true });
        });
        item.append(link);
        list.append(item);
      });
      tooltip.addEventListener('pointerenter', () => clearTimeout(closeTimer));
      tooltip.addEventListener('pointerleave', scheduleHide);
      list.addEventListener('scroll', hide, { passive: true });
      summary.addEventListener('click', (event) => { if (desktop.matches) event.preventDefault(); });
      details.append(summary, list);
      nav.append(details, tooltip);
      layout.prepend(nav);
      layout.classList.add('cutim-article-layout--toc');
      const onResize = () => { details.open = desktop.matches; hide(); };
      const onKeydown = (event) => { if (event.key === 'Escape') hide(); };
      desktop.addEventListener('change', onResize);
      document.addEventListener('keydown', onKeydown);
      window.addEventListener('scroll', hide, { passive: true });
      const onUnload = (event) => {
        if (!event.target.contains(layout)) return;
        hide();
        desktop.removeEventListener('change', onResize);
        document.removeEventListener('keydown', onKeydown);
        window.removeEventListener('scroll', hide);
        document.removeEventListener('shopify:section:unload', onUnload);
        nav.remove();
        layout.classList.remove('cutim-article-layout--toc');
        delete body.dataset.tocReady;
      };
      document.addEventListener('shopify:section:unload', onUnload);
    });
  }
  window.cutimArticleToc = { initialize };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
